// Status Badge Component
// Professional status indicator using design system tokens

import React from 'react';
import { useTheme } from '../../design-system/ThemeProvider';

interface StatusBadgeProps {
  status: 'running' | 'stopped' | 'starting' | 'error';
  children?: React.ReactNode;
  showIndicator?: boolean;
  size?: 'sm' | 'md';
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({
  status,
  children,
  showIndicator = true,
  size = 'sm'
}) => {
  const { theme } = useTheme();

  const getStatusStyles = () => {
    return theme.componentTokens.statusBadge[status];
  };

  const statusStyles = getStatusStyles();

  const badgeStyles: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing[2],
    padding: size === 'sm' ? `${theme.spacing[1]} ${theme.spacing[2]}` : `${theme.spacing[2]} ${theme.spacing[3]}`,
    borderRadius: theme.borderRadius['2xl'],
    backgroundColor: statusStyles.background,
    border: `1px solid ${statusStyles.border}`,
    color: statusStyles.text,
    fontSize: size === 'sm' ? theme.typography.fontSize.xs : theme.typography.fontSize.sm,
    fontWeight: theme.typography.fontWeight.medium,
    textTransform: 'capitalize' as const
  };

  const indicatorStyles: React.CSSProperties = {
    width: '6px',
    height: '6px',
    borderRadius: '50%',
    backgroundColor: statusStyles.indicator,
    animation: status === 'running' ? 'pulse 2s infinite' : undefined
  };

  return (
    <div style={badgeStyles}>
      {showIndicator && <div style={indicatorStyles} />}
      {children || status}
    </div>
  );
};